"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.selectPropTypes = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 *
 * `Select` A somewhat styled select with props for focused/unfocused classNames
 * and handlers for common events. Uses a wrapper `div` with option to pass a custom
 * "arrow" component that can be used to display an arrow at the right of a select.
 *
 * Note: any valid select attribute can be passed as a prop and will
 * get rendered via the `...rest` spreaded prop.
 *
 */


var Select = function Select(_ref) {
  var _classNames;

  var value = _ref.value,
      options = _ref.options,
      Arrow = _ref.arrow,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      focusedClassName = _ref.focusedClassName,
      unFocusedClassName = _ref.unFocusedClassName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["value", "options", "arrow", "onChange", "onFocus", "onBlur", "focusedClassName", "unFocusedClassName", "className"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var select = (0, _react.useRef)(null);

  var toggleFocus = function toggleFocus() {
    if (!isFocused && onFocus) {
      onFocus();
    } else if (isFocused && onBlur) {
      onBlur();
    }

    setIsFocused(!isFocused);
  };

  var handleChange = function handleChange(event) {
    if (onChange) {
      onChange(event);
    }
  }; // If value is empty and the first option is real (i.e., not something like "Select one..."),
  // then trigger `handleChange` to set the value to the first option.


  (0, _react.useEffect)(function () {
    if (!value && options[0].value) {
      // Simulating js event object shape "event.target.value"
      handleChange({
        target: {
          value: options[0].value
        }
      });
    }
  }, [value]);
  return _react.default.createElement("div", {
    className: "relative"
  }, _react.default.createElement("select", _extends({}, rest, {
    className: (0, _classnames.default)((_classNames = {
      "CosmicSelect w-full outline-none active:outline-none appearance-none transition": true
    }, _defineProperty(_classNames, unFocusedClassName, !isFocused), _defineProperty(_classNames, focusedClassName, isFocused), _classNames), className),
    ref: select,
    value: value,
    onChange: handleChange,
    onFocus: toggleFocus,
    onBlur: toggleFocus
  }), options.map(function (_ref2) {
    var _value = _ref2.value,
        title = _ref2.title,
        label = _ref2.label;
    return _react.default.createElement("option", {
      key: _value,
      value: _value
    }, title || label);
  })), _react.default.createElement(Arrow, null));
};

var DefaultArrow = function DefaultArrow() {
  return _react.default.createElement("svg", {
    width: "20px",
    height: "10px",
    viewBox: "0 0 20 10",
    className: "absolute pointer-events-none fill-current",
    style: {
      top: "50%",
      right: ".75rem",
      transform: "translateY(-50%)"
    }
  }, _react.default.createElement("polygon", {
    points: "0, 0 20, 0 10, 10"
  }));
};

var selectPropTypes = {
  value: _propTypes.default.string.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string.isRequired,
    title: _propTypes.default.string,
    label: _propTypes.default.string
  })).isRequired,
  arrow: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  className: _propTypes.default.string,
  focusedClassName: _propTypes.default.string,
  unFocusedClassName: _propTypes.default.string
};
exports.selectPropTypes = selectPropTypes;
Select.propTypes = selectPropTypes;
Select.defaultProps = {
  arrow: DefaultArrow,
  onChange: null,
  onFocus: null,
  onBlur: null,
  className: "",
  focusedClassName: "",
  unFocusedClassName: ""
};
var _default = Select;
exports.default = _default;